import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { useDeterminateProgress } from './hooks';

interface StandardProgressBarProps {
  text: string;
  mode: 'determinate' | 'indeterminate';
  progress: number;
  speed: number;
}

/**
 * Standard Material-UI progress bar component used on addedit hosts.
 * Supports both determinate and indeterminate modes.
 */
export const StandardProgressBar: React.FC<StandardProgressBarProps> = ({
  text,
  mode,
  progress: initialProgress,
  speed,
}) => {
  const progress = useDeterminateProgress(mode, initialProgress, speed);

  return (
    <Box sx={{ width: '100%', margin: 'auto' }}>
      <LinearProgress
        variant={mode}
        value={mode === 'determinate' ? progress : undefined}
        sx={{
          height: 10,
          borderRadius: 5,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor:
              mode === 'indeterminate' ? 'primary.main' : undefined,
          },
          '& .MuiLinearProgress-bar1Indeterminate': {
            backgroundColor: 'primary.main',
          },
          '& .MuiLinearProgress-bar2Indeterminate': {
            backgroundColor: 'primary.dark',
          },
          '& .MuiLinearProgress-bar1Determinate': {
            backgroundColor: 'primary.main',
          },
        }}
      />
      <Box sx={{ mt: 1 }}>
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            fontSize: { xs: '0.875rem', sm: '1rem' },
          }}
        >
          {text}
          {mode === 'determinate' && ` ${Math.round(progress)}%`}
        </Typography>
      </Box>
    </Box>
  );
};
